import {helpers} from 'commerce-sdk-isomorphic'
import {
    WITHDRAWAL_HOOK_API_NAME,
    WITHDRAWAL_HOOK_API_VERSION,
    WITHDRAWAL_HOOK_RESOURCE
} from '@consteed/overrides/constants'

export const buildWithdrawalPayload = ({name, email, orderNumber}) => ({
    name: name?.trim(),
    email: email?.trim(),
    orderNumber: orderNumber?.trim()
})

export const submitWithdrawalRequest = async ({
    config,
    accessToken,
    siteId,
    formData
}) => {
    const globalHeaders = config.headers || {}
    const payload = buildWithdrawalPayload(formData)

    return helpers.callCustomEndpoint({
        clientConfig: {
            parameters: {
                clientId: config.clientId,
                siteId,
                organizationId: config.organizationId,
                shortCode: config.shortCode
            },
            proxy: config.proxy,
            throwOnBadResponse: true
        },
        options: {
            method: 'POST',
            customApiPathParameters: {
                apiName: WITHDRAWAL_HOOK_API_NAME,
                apiVersion: WITHDRAWAL_HOOK_API_VERSION,
                endpointPath: WITHDRAWAL_HOOK_RESOURCE
            },
            parameters: {
                siteId
            },
            headers: {
                ...globalHeaders,
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }
    })
}

export const parseWithdrawalError = async (error) => {
    if (!error) {
        return null
    }

    if (error.response?.json && typeof error.response.json === 'function') {
        try {
            const body = await error.response.clone().json()
            return body.detail || body.message || body.title || body.error || null
        } catch (parseError) {
            try {
                const text = await error.response.clone().text()
                if (text) {
                    return parseWithdrawalError(text)
                }
            } catch (textError) {
                // fall through
            }
        }
    }

    if (typeof error === 'string') {
        try {
            const parsed = JSON.parse(error)
            return parsed.detail || parsed.message || parsed.title || error
        } catch (parseError) {
            return error
        }
    }

    if (error.detail || error.message || error.title || error.error) {
        return error.detail || error.message || error.title || error.error
    }

    return null
}
